import React from 'react';
import { Modal } from 'react-bootstrap';
import { getLabel } from '../../language'
import Slider from "react-rangeslider";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

const mapStateToProps = state => ({
    anonymousMode: state.user.anonymousMode
});

const ElectionVoteModal = props => {
    return (
        <Modal
            show={props.isElectionVoteModalOpen}
            className={`polly-modal vote-popup ${props.anonymousMode ? "cw" : ""}`}
            aria-labelledby="contained-modal-title-lg"
            onHide={props.isElectionVoteModel}>
            <div id="votepopup">
                <div className={`modal-header${props.anonymousMode ? "-dark" : ""}`}>
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className={`pollname mb-3 ${props.anonymousMode ? "cw" : ""}`}>
                                {getLabel(252)} {props.displayName ? props.displayName : "Undecided"}
                            </h3>
                        </div>
                    </div>
                    <button className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" className="text-dark" onClick={props.isElectionVoteModel}>×</span>
                    </button>
                </div>
                <div className={`modal-body${props.anonymousMode ? "-dark" : ""}`}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className={`mainpolinfo`}>
                                <div className={`howdoyoufeel${props.anonymousMode ? "-dark" : ""} d-flex`}>
                                    <textarea className={`form-control${props.anonymousMode ? "-dark cw" : ""}`}
                                              name="electionComment"
                                              value={props.electionComment}
                                              onChange={(e) => props.onChange(e)}
                                              placeholder={getLabel(109)}/>
                                    {props.displayName ?<div className="votescore mt-3">
                                        <div className="row">
                                            <div className="col-md-3 vote-col-name">
                                                <span>{getLabel(111)}</span>({props.vision})
                                            </div>
                                            <div className="col-md-9">
                                                <Slider min={1} max={10} step={1} value={props.vision}
                                                        orientation="horizontal"
                                                        onChange={(e) => props.handleOnSlider(e, 'vision')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-3 vote-col-name">
                                                <span>{getLabel(110)}</span>({props.ability})
                                            </div>
                                            <div className="col-md-9">
                                                <Slider min={1} max={10} step={1} value={props.ability}
                                                        orientation="horizontal"
                                                        onChange={(e) => props.handleOnSlider(e, 'ability')}
                                                />
                                            </div>
                                        </div>
                                    </div>:null}
                                    <div className="m-1">
                                        <legend className={`${props.anonymousMode ? "cw" : ""}`}>{getLabel(105)}</legend>
                                        <fieldset className={`form-group privacy-list${props.anonymousMode ? "-dark" : ""}`}>
                                            <div className="form-check">
                                                <input type="radio"
                                                       className="form-check-input"
                                                       onChange={(e) => props.onChange(e)}
                                                       name="viewMyVotes"
                                                       id="viewMyVotes2"
                                                       value="2"
                                                       checked={props.viewMyVotes === 2}
                                                />
                                                <label className="form-check-label" htmlFor="viewMyVotes2">{getLabel(72)}</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="radio"
                                                       className="form-check-input"
                                                       onChange={(e) => props.onChange(e)}
                                                       name="viewMyVotes"
                                                       id="viewMyVotes3"
                                                       value="3"
                                                       checked={props.viewMyVotes === 3}
                                                />
                                                <label className="form-check-label" htmlFor="viewMyVotes3">{getLabel(73)}</label>
                                            </div>
                                            <div className="form-check">
                                                <input type="radio"
                                                       className="form-check-input"
                                                       onChange={(e) => props.onChange(e)}
                                                       name="viewMyVotes"
                                                       id="viewMyVotes4"
                                                       value="4"
                                                       checked={props.viewMyVotes === 4}
                                                />
                                                <label className="form-check-label" htmlFor="viewMyVotes4">{getLabel(78)}</label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <div className="d-flex w-100 mt-2">
                                    <button className={`btn btn-primary${props.anonymousMode ? "-dark" : ""} ml-auto`}
                                            onClick={props.isElectionVoteSubmit}>{getLabel(227)}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
};

export default withRouter(connect(mapStateToProps)(ElectionVoteModal));

